import React from "react";
import HeaderStatus from "./HeaderStatus/index.js";
import closeImg from "../../Assets/images/close.svg";
import { isMobile } from "../../utils/utils.js";
import { showCalendarClass } from "../../actions/dashBoardActions";
import { connect } from "react-redux";
import { convertToIST} from "./agentUtils.js";
import { addEllipsisToText } from "../../utils/utils";


class MobileAgentPopUp extends React.Component {
  closeModal = () => {
    this.props.onClose && this.props.onClose();
  };
  componentDidMount = () => {
    this.props.showCalendarClass(true);
  };
  componentWillUnmount = () => {
    this.props.showCalendarClass(false);
  };
  render() {
    const {
      cssClass,
      children,
      heading,
      showStatus,
      showOnDesktop,
      details,
      addAutoUnderWritingCss,
      showExceptionStatus,
      popUpBottom,
      removeHeader,
      popupHead,
      customerDetail,
      revisedSA,
      hasDiscrepancyRaised,
      hasDiscrepancy
    } = this.props;
    const status =
      details && details.journeyStatus && details.journeyStatus.split("_");

    const customerConsentList = customerDetail?.newgenStatusResponseDTOList


    const renderNumber = (num) => {
      let value = num
        ?.toString()
        .replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
      return value;
    };

    const renderDate = (date) => {
      const istDate = convertToIST(date, false);
      return istDate;
    };
    const consentDate = customerConsentList?.find(
      (item) => item?.subStatus === "CUSTOMER_CONSENT_STATUS"
    );
    const matched = customerConsentList?.filter(
      (item) => item?.subStatus === "CUSTOMER_CONSENT_STATUS"
    );
    const consentSentDate = renderDate(consentDate?.updatedOn) || "NA";
    const consentStatusCodeRecived = matched?.length > 0 ? matched[0]?.additionalInfo?.consentStatusCode || null : null;
    const consentAcceptedRejected = matched?.[0]?.additionalInfo?.accepted ?? null;
    // Get pendingWith from QUOTE status item
    let pendingWith = '';
    if (customerConsentList && customerConsentList?.length > 0) {
      const firstAvailable = customerConsentList?.find(
        (item) => item?.status === 'QUOTE'
      );
      pendingWith = firstAvailable?.pendingWith || '';
    }
      const paymentList = customerDetail?.proposalBasicDetails?.methodOfPayments || [];

      const basbaObj = paymentList?.find(
      item => item.basbaTracker && item.basbaTracker !== "null"
      );

      const basbaStatus =
      basbaObj?.basbaTracker ??
      customerDetail?.proposalBasicDetails?.consentDetail?.status;

      const basbaRemark = basbaStatus === "Deactivate"  ?
      customerDetail?.proposalBasicDetails?.consentDetail?.basbaRemark : null;

    // console.log('customerDetail',customerDetail?.newgenStatusResponseDTOList)
    return (
      <div
        role="mobilePopup_testRole"
        data-testid="mobilePopup_testId"
        className={`mainPopUpWrap ${popUpBottom ? "popUpBottomCss" : ""
          } ${cssClass} ${!isMobile() && showOnDesktop ? "showOnDesktop" : ""}`}
      >
        <span className={`backgroundOverlay`} onClick={this.closeModal} />
        <div className="mobilePopUpWrap ">
          {removeHeader ? null : (
            <div className="pop-top-sec">
              {this.props.popupHead ? (
                <div
                  data-testid="mobilePopup_cancelBtn"
                  className="popup-header"
                >
                  {popupHead}
                </div>
              ) : (
                ""
              )}
              <span className="close-btn" onClick={this.closeModal}>
                <img alt="Close" src={closeImg} />
              </span>
              {heading && <div className="heading">{heading?.toUpperCase()}</div>}
              {showExceptionStatus && (
                <div className="showstatusWrap">
                  <div className="left-col">
                    <p>
                      <span>Plan:</span>{" "}
                      {customerDetail && customerDetail?.proposalBasicDetails?.planName}
                    </p>
                    <p>
                      <span>Proposal Number:</span>{" "}
                      {customerDetail && customerDetail?.proposalBasicDetails?.proposalNumber}
                    </p>
                    {customerDetail?.proposalBasicDetails?.pivcDetails && <p className="exc-pn">
                      <span>PIVC Required:</span>{" "}
                      {customerDetail?.proposalBasicDetails?.pivcDetails?.isEligible === "Required" ? "Yes" : "No"}
                    </p>}
                  </div>
                </div>
              )}
              {showStatus && (
                <div className="showstatusWrap">
                  <ul>
                    <li>
                      <p>Premium</p>
                      <span>
                        <>&#8377; </>
                        {customerDetail?.proposalBasicDetails?.premium
                          ? renderNumber(customerDetail?.proposalBasicDetails?.premium)
                          : "-"}
                      </span>
                    </li>
                    {
                      //  revisedSA && 
                      <li>
                        <p>Sum Assured</p>
                        <span>
                          <>&#8377; </>
                          {
                            revisedSA != null && revisedSA !== ''
                              ? revisedSA
                              : (customerDetail?.proposalBasicDetails?.sumAssured != null &&
                                customerDetail?.proposalBasicDetails?.sumAssured !== '')
                                ? renderNumber(customerDetail?.proposalBasicDetails?.sumAssured)
                                : "-"
                          }
                        </span>
                      </li>
                    }
                    <li>
                      <p>Actionable</p>
                      <span>
                        {pendingWith ? pendingWith
                          : "-"}
                      </span>
                    </li>
                    <li></li>
                  </ul>
                </div>
              )}
              {/* header status shown */}

              <HeaderStatus
                bannerDetail={customerDetail?.proposalBasicDetails}
                accordionListDetails={customerDetail?.newgenStatusResponseDTOList}
                consentAccepted={customerDetail?.proposalBasicDetails?.consentDetail?.accepted}
                hasDiscrepancy={hasDiscrepancy}
                hasDiscrepancyRaised={hasDiscrepancyRaised}
                customerDetail={customerDetail}
              />

              {consentStatusCodeRecived === "FJ" && consentDate && consentAcceptedRejected === null && (
                <div className="Customer-date-text">
                  <span className="consentTextColor">
                    Customer Consent Sent On:
                  </span>
                  {consentSentDate}
                </div>
              )}

           {/* basba status */}

            {basbaStatus && (
            <div className="Customer-date-text text-bold font-14">
            BASBA Status: {basbaStatus} {basbaRemark && ` ( ${addEllipsisToText(basbaRemark)} )`} 
            </div>
            )}
            </div>
          )}
          <div className="pop-btm-sec">{children}</div>
        </div>
      </div>
    );
  }
}

const actions = {
  showCalendarClass,
};

export default connect(null, actions)(MobileAgentPopUp);
